package fr.arcplex.network.model

import fr.arcplex.network.http.Serializer
import fr.arcplex.network.template.CoherenceProgramTemplate
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.contentOrNull

/**
 * Everything the Coherence film screen renders: the programme contents, the
 * parsed KDL template, and the raw bodies used as escape hatches.
 */
data class CoherenceFilmInfo(
    val contents: CoherenceProgramContents,
    val template: CoherenceProgramTemplate,
    val templateBody: String,
    val contentBody: String = "",
    val rawJson: String = "",
    val boxType: String = "",
    val contentType: String = "",
    val templateRevision: Int = 0,
    val fallback: String = ""
) {
    fun get(key: String): String? {
        val obj = runCatching { Serializer.json.parseToJsonElement(rawJson) as? JsonObject }.getOrNull()
            ?: return null
        val value = obj[key] ?: return null
        return when (value) {
            is JsonPrimitive -> value.contentOrNull
            else -> value.toString()
        }
    }
}
